import { RequestController } from "./controller";

import { admin } from "./admin.api";
import { agentInvoice } from "./agent_invoice.api";
import { agentPayment } from "./agent_payment.api";
import { agentSettlement } from "./agent_settlement.api";
import { agentSubscription } from "./agent_subscription.api";
import { apiKey } from "./api_key.api";
import { associate } from "./associate.api";
import { associateAgent } from "./associate_agent.api";
import { associateLegals } from "./associate_legals.api";
import { associateMarketing } from "./associate_marketing.api";
import { associatePresence } from "./associate_presence.api";
import { associateRegistration } from "./associate_registration.api";
import { associateSettings } from "./associate_settings.api";
import { associateUser } from "./associate_user.api";
import { associateWagent } from "./associate_wagent.api";
import { auditProductInternet } from "./audit_product_internet.api";
import { auditSubscription } from "./audit_subscription.api";
import { auditor } from "./auditor.api";
import { get, post, postEmpty } from "./common";
import { customer } from "./customer.api";
import { customerComplaint } from "./customer_complaint.api";
import { customerImport } from "./customer_import.api";
import { customerInvoice } from "./customer_invoice.api";
import { customerRegistration } from "./customer_registration.api";
import { dashboard } from "./dashboard.api";
import { debugTools } from "./debug_tools.api";
import { devtools } from "./devtools.api";
import { featureToggles } from "./feature_toggles.api";
import { financeAccount } from "./finance_account.api";
import { financeDisbursement } from "./finance_disbursement.api";
import { financeDisbursementAccount } from "./finance_disbursement_account.api";
import { financeInvoice } from "./finance_invoice.api";
import { financePayment } from "./finance_payment.api";
import { financeReport } from "./finance_report.api";
import { financeTax } from "./finance_tax.api";
import { hotspotSession } from "./hotspot_session.api";
import { hotspotTemplate } from "./hotspot_template.api";
import { hotspotVoucher } from "./hotspot_voucher.api";
import { legals } from "./legals.api";
import { marketingDisbursement } from "./marketing_disbursement.api";
import { marketingInvoice } from "./marketing_invoice.api";
import { marketingSubscription } from "./marketing_subscription.api";
import { networkGroup } from "./network_group.api";
import { networkOLT } from "./network_olt.api";
import { networkONT } from "./network_ont.api";
import { networkONTBlock } from "./network_ont_block.api";
import { networkPOP } from "./network_pop.api";
import { networkUsage } from "./network_usage.api";
import { notification } from "./notification.api";
import { privilege } from "./privilege.api";
import { productBroadband } from "./product_broadband.api";
import { productDedicated } from "./product_dedicated.api";
import { productHotspot } from "./product_hotspot.api";
import { provision } from "./provision.api";
import { provisionReturn } from "./provision_return.api";
import { radiusAccount } from "./radius_account.api";
import { radiusNAS } from "./radius_nas.api";
import { radiusServer } from "./radius_server.api";
import { radiusSession } from "./radius_session.api";
import { reseller } from "./reseller.api";
import { resellerInvoice } from "./reseller_invoice.api";
import { resellerRegistration } from "./reseller_registration.api";
import { settings } from "./settings.api";
import { skipAuditSubscription } from "./skip_audit_subscription.api";
import { subscription } from "./subscription.api";
import { subscriptionDismantle } from "./subscription_dismantle.api";
import { subscriptionProductChange } from "./subscription_product_change.api";
import { systemDisbursement } from "./system_disbursement.api";
import { user } from "./user.api";
import { warehouseItem } from "./warehouse_item.api";
import { warehouseItemType } from "./warehouse_item_type.api";
import { warehouseLocation } from "./warehouse_location.api";
import { whatsAppInvoice } from "./whatsapp_invoice.api";
import { whatsAppMessage } from "./whatsapp_message.api";
import { whatsAppUsage } from "./whatsapp_usage.api";

export const api = {
    raw: {
        get: get,
        post: post,
        postEmpty: postEmpty,
    },
    admin: admin,
    agentInvoice: agentInvoice,
    agentPayment: agentPayment,
    agentSettlement: agentSettlement,
    agentSubscription: agentSubscription,
    apiKey: apiKey,
    associate: associate,
    associateAgent: associateAgent,
    associateLegals: associateLegals,
    associateMarketing: associateMarketing,
    associatePresence: associatePresence,
    associateRegistration: associateRegistration,
    associateSettings: associateSettings,
    associateUser: associateUser,
    associateWagent: associateWagent,
    auditor: auditor,
    auditProductInternet: auditProductInternet,
    auditSubscription: auditSubscription,
    customer: customer,
    customerComplaint: customerComplaint,
    customerImport: customerImport,
    customerInvoice: customerInvoice,
    customerRegistration: customerRegistration,
    dashboard: dashboard,
    debugTools: debugTools,
    devtools: devtools,
    featureToggles: featureToggles,
    financeAccount: financeAccount,
    financeDisbursement: financeDisbursement,
    financeDisbursementAccount: financeDisbursementAccount,
    financeInvoice: financeInvoice,
    financePayment: financePayment,
    financeReport: financeReport,
    financeTax: financeTax,
    hotspotSession: hotspotSession,
    hotspotTemplate: hotspotTemplate,
    hotspotVoucher: hotspotVoucher,
    legals: legals,
    marketingDisbursement: marketingDisbursement,
    marketingInvoice: marketingInvoice,
    marketingSubscription: marketingSubscription,
    networkGroup: networkGroup,
    networkOLT: networkOLT,
    networkONT: networkONT,
    networkONTBlock: networkONTBlock,
    networkPOP: networkPOP,
    networkUsage: networkUsage,
    notification: notification,
    privilege: privilege,
    productBroadband: productBroadband,
    productDedicated: productDedicated,
    productHotspot: productHotspot,
    provision: provision,
    provisionReturn: provisionReturn,
    radiusAccount: radiusAccount,
    radiusNAS: radiusNAS,
    radiusServer: radiusServer,
    radiusSession: radiusSession,
    reseller: reseller,
    resellerInvoice: resellerInvoice,
    resellerRegistration: resellerRegistration,
    settings: settings,
    skipAuditSubscription: skipAuditSubscription,
    subscription: subscription,
    subscriptionDismantle: subscriptionDismantle,
    subscriptionProductChange: subscriptionProductChange,
    systemDisbursement: systemDisbursement,
    user: user,
    warehouseItem: warehouseItem,
    warehouseItemType: warehouseItemType,
    warehouseLocation: warehouseLocation,
    whatsAppInvoice: whatsAppInvoice,
    whatsAppMessage: whatsAppMessage,
    whatsAppUsage: whatsAppUsage,
};

export type ApiResponseFn<T extends (...x: any) => RequestController<any>> = Awaited<
    ReturnType<ReturnType<T>["execute"]>
>;
